<template>
  <div class="">
    <div class="mb-3 px-2 text-lg">
      {{ $t('titles.Construction progress') }}:
    </div>
    <div
      class="custom-scroll-x flex snap-x snap-mandatory gap-2 overflow-x-auto px-2 pb-1 pt-1"
    >
      <div
        v-for="item in albums"
        :key="item.id"
        class="group/progress h-54 relative w-36 shrink-0 cursor-pointer snap-start scroll-mx-2 overflow-hidden rounded-lg"
        :class="{
          'ring-primary ring-2':
            item.id == sidebarModal?.payload?.id &&
            sidebarModal.type == 'image-construction',
        }"
        @click.prevent="openAlbum(item)"
      >
        <div
          class="absolute bottom-0 left-0 flex h-20 w-full flex-col justify-end bg-gradient-to-t from-black/80 to-transparent px-2 pb-3 text-white transition-colors group-hover/progress:from-black/90"
        >
          <span>
            {{ item.date }}
          </span>
          <span class="text-xs leading-[1]">
            {{ item.year }}
          </span>
        </div>
        <img :src="item.media_url" class="h-full object-cover" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'ConstructionProgress',
  props: {
    progress: {
      type: [Array],
      required: true,
    },
    sidebar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['sidebarModal']),

    albums() {
      return this.progress.map((alb) => {
        let date = new Date(alb.date);
        let formattedDate = date.toLocaleDateString(this.locale, {
          month: 'long',
          day: 'numeric',
        });
        return {
          id: alb.id,
          media_url: alb.media_url,
          date: formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1),
          year: date.toLocaleDateString(this.locale, {
            year: 'numeric',
          }),
        };
      });
    },

    currentAlbumId() {
      return this.sidebarModal?.payload.id;
    },

    locale() {
      let locale = this.$i18n.locale;
      if (locale == 'us') {
        locale = 'en';
      }
      return locale;
    },
  },
  methods: {
    ...mapActions(['OPEN_SIDEBAR_MODAL']),

    async openAlbum(progress) {
      this.OPEN_SIDEBAR_MODAL({
        type: 'image-construction',
        sidebar_id: this.sidebar.id,
        payload: {
          id: progress.id,
        },
      });
    },
  },
};
</script>

<style scoped></style>
